import { useActions } from '../../Actions';
import { useAccountIds } from '../../auth/accessToken/withAccountIds';
import useHasAnyOfScopes from '../../common/hooks/useHasAnyOfScopes';
import { pdSelector } from '../../payout/merchant/config/selectors';
import { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { PayoutDestinationWithBankAccounts } from '../../settings/payoutDestinations/PayoutDestinationsList';

type PayoutDestinationReturnType = {
    payoutDestination: PayoutDestinationWithBankAccounts;
}

export const usePayoutDestination = (id: string) => {
    const actions = useActions('payout.config');
    const fetchPayoutDestinations = actions.getPayoutDestinations;
    const fetchPayoutDestinationsRef = useRef(fetchPayoutDestinations);
    const accountIds = useAccountIds();
    const accountId = accountIds.prodAccountId;
    const hasScopes = useHasAnyOfScopes(['admin:payout']);
    const { payoutDestinations, loading } = useSelector(pdSelector(accountId || ''));
    useMemo(() => {
        if (accountId && payoutDestinations.length === 0 && !loading && hasScopes) {
            fetchPayoutDestinationsRef.current(accountId);
        }
    }, [accountId, loading, payoutDestinations, hasScopes]);

    return { payoutDestination: payoutDestinations.find(x => x.id === id) } as PayoutDestinationReturnType;
};
